import React, { useState } from 'react';
import { FormProvider } from '@/Hooks/useFormWrapper';
import { useLocalization } from '@/Hooks';
import { ModalProps } from '@/Types';
import styles from './OrderAutomatizationModal.scss';
import { PagesRouting } from '@/Routing';
import { OrderAutomatizaionTableMemo } from './modules/OrderAutomatizationTable/OrderAutomatizationTable';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { Link } from '@/Components/Controls/Link/Link';
import { Modal } from '@/Components/Modal/Modal';
import { useOrderAutomatizationModalForm } from './hooks/useOrderAutomatizationModalForm';
import { useOrderAutomatizationModalOptions } from './hooks/useOrderAutomatizationModalOptions';
import { useOrderAutomatizationModalLoader } from './hooks/useOrderAutomatizationModalLoader';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = ModalProps;

export function OrderAutomatizaionModal({ closeModalWindow }: Props) {
  const {
    buttons: { Cancel },
    modalWindows: {
      orderLinkWithProduct: { Description, Buttons },
    },
  } = useLocalization();

  const [isSaveMixAutomationRules, setIsSaveMixAutomationRules] = useState(false);

  const {
    orderPackages,
    selectedOrderIds,
    editableOrderIds,
    orderAutomatizationRows,
  } = useOrderAutomatizationModalOptions();

  useOrderAutomatizationModalLoader(editableOrderIds, selectedOrderIds);

  const { methods, onSubmit } = useOrderAutomatizationModalForm(
    orderAutomatizationRows,
    orderPackages,
    isSaveMixAutomationRules,
  );

  return (
    <Modal
      modalClassName={styles.modal}
      onClose={closeModalWindow}
      shouldCloseOnOverlayClick={false}
      tourKey={'shippingLabelTour'}
      description={{
        title: Description.Title,
        text: Description.Text,
      }}
    >
      <FormProvider {...methods}>
        <form className={styles.formWrapper} onSubmit={onSubmit}>
          <OrderAutomatizaionTableMemo />

          <ButtonsWrapper position={'space-between'}>
            <Link to={PagesRouting.SettingsPages.ShippingAutomationSettings.AmountAutomation}>
              <Button text={Buttons.PackageAutomationRules} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} />
            </Link>

            <div>
              <Button text={Cancel} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} onClick={closeModalWindow} />
              <Button
                text={Buttons.SavePackages}
                theme={BUTTON_THEMES.INFO_LIGHT}
                type={'submit'}
                onClick={() => setIsSaveMixAutomationRules(false)}
              />
              <Button
                text={Buttons.SavePackagesTemplates}
                theme={BUTTON_THEMES.SUCCESS}
                type={'submit'}
                onClick={() => setIsSaveMixAutomationRules(true)}
                //disabled={isPackageRequired}
                disabled={true}
                className={styles.sendRules}
              />
            </div>
          </ButtonsWrapper>
        </form>
      </FormProvider>
    </Modal>
  );
}
